import { gql } from "@grandvisionhq/graphql";
const calendarAvailabilityById = gql`
  fragment CalendarAvailabilityById on Availability {
    perDay
    percentageAvailable
    slotsAvailable
    store {
      globalStoreId
    }
  }
`;
const GET_CALENDAR_AVAILABILITY_BY_ID = gql`
  query GetCalendarAvailabilityById(
    $appointmentTypeIds: [ID!]!
    $endDate: String!
    $endTime: String
    $startDate: String!
    $startTime: String
    $globalStoreIds: [String!]
  ) {
    availabilityByStoreCodes(
      appointmentTypeIds: $appointmentTypeIds
      endDate: $endDate
      endTime: $endTime
      startDate: $startDate
      startTime: $startTime
      globalStoreIds: $globalStoreIds
    ) {
      ...CalendarAvailabilityById
    }
  }
  ${calendarAvailabilityById}
`;
export {
  GET_CALENDAR_AVAILABILITY_BY_ID
};
//# sourceMappingURL=get-calendar-availability-by-id.js.map
